import React from 'react';
import Hero from './components/Hero';
import About from './components/About';
import Projects from './components/Projects';
import Footer from './components/Footer';
import DotNav from './components/DotNav';
import { usePortfolioEffects } from './main';
import './styles.css';
import styled from 'styled-components';
import Block from '../Common/Block';
import { shallowEqual, useSelector } from 'react-redux';
import * as Module from "../../modules";

const Wrapper = styled.div`
  width: 100%;
  max-width: 100% !important;
  scroll-snap-type: y mandatory; /* y 축 방향으로만 scroll snap 적용 */
  overflow: auto;
  & > section {
    scroll-snap-align: start; /* 스크롤 위치 맞춤 */
  }
`;

const Home: React.FC = () => {
  usePortfolioEffects();

  const { isBlock } = useSelector((state: Module.RootState) => ({isBlock: state.block.status}), shallowEqual);
  
  return (
    <Wrapper>
      {isBlock && <Block />}
      <Hero />
      <About />
      <Projects />
      <Footer />
      <DotNav />
    </Wrapper>
  );
};

export default Home;